<template>
	<div class="yiContainer">
		<full-page :options="options" ref="fullpage">
			<div class="section pageBox1">
				<!-- 导航 -->
				<div class="navBar">
					<img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()">
					<ul class="navBarItem">
						<!-- <li class="busiz-active-sel">
							<router-link exact to="/" tag="a">首页</router-link>
						</li> -->
						<li>
							<router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link>
						</li>
						<el-dropdown>
							<li class="brandLi">
								<router-link exact to="/huaiBrand" style="font-size:1em;" tag="a">兰树品牌</router-link>
							</li>
							<el-dropdown-menu class="elDropdown" exact slot="dropdown"
								style="background:rgb(236,245,255)!important;">
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '1' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/huaiBrand" tag="a">淮树</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '2' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/brand" tag="a">心清堂</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '3' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/shuiBrand" tag="a">水姻缘</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '4' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/yiBrand" tag="a">一清堂</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li><router-link :class="brandActive == '5' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/zhongBrand" tag="a">Dr.CHUNG<span
												style="vertical-align: super;">+</span></router-link></li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/lanshuBrand" tag="a">兰树</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '7' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/zbqfBrand" tag="a">植本清方</router-link>
									</li>
								</el-dropdown-item>

							</el-dropdown-menu>
						</el-dropdown>
						<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
						<li>
							<router-link to="/brandLanshu" exact tag="a">美业菩提</router-link>
						</li>
						<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>
						
						<li>
							<router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link>
						</li>
						
						<li>
							<router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link>
						</li>
					</ul>
				</div>

				<div class="topBgBox" @click="enterProducts(3)">
					<img class="topBgBoxImg" src="../assets/yiBrand/yqtTopNew.png" alt="">
				</div>

			</div>
			<div class="section pageBox2">
				<div class="seriesTitle">一清堂品牌系列产品</div>
				<div class="seriesMainBox">
					<div class="seriesMainBoxItem seriesMainBoxItem1">
						<img class="seriesItemImg1 seriesItemImg" src="../assets/yiBrand/yuzhu-1.png" alt=""
							@click="enterProducts(3)">
					</div>
					<div class="seriesMainBoxItem seriesMainBoxItem2">
						<img class="seriesItemImg2 seriesItemImg" src="../assets/yiBrand/yilihe-2.png" alt=""
							@click="enterProducts(3)">
					</div>
					<div class="seriesMainBoxItem seriesMainBoxItem3">
						<img class="seriesItemImg3 seriesItemImg" src="../assets/yiBrand/xueju-3.png" alt=""
							@click="enterProducts(3)">
					</div>
					<div class="seriesMainBoxItem seriesMainBoxItem4">
						<img class="seriesItemImg4 seriesItemImg" src="../assets/yiBrand/yangshen-4.png" alt=""
							@click="enterProducts(3)">
					</div>
				</div>
			</div>
			<div class="section pageBox3">
				<div class="pageBoxItemBox">
					<div class="pageBoxItemBoxLeft">
						<img class="ItemBoxLeftImg" src="../assets/yiBrand/originImg1.png" alt="">
					</div>
					<div class="pageBoxItemBoxRight">
						<div class="pageBoxItemBoxRightText">
							一清堂即是由兰树企业创始人钟鸣先生<br />
							由此首诗句发想而来，<br />
							以期每一位爱美人士，能在舒适的护肤体验中，<br />
							修得身、心、灵的清静、平和与从容。
						</div>
						<div class="pageBoxItemBoxRightImg">
							<img class="ItemBoxRightImg" src="../assets/yiBrand/originImg2.png" alt="">
						</div>
					</div>
				</div>
			</div>
			<div class="section pageBox4">
				<div class="pageBoxMain4">
					<div class="pageBoxMainTop">

						<div class="pageBoxMainTopLeftTitle">
							奉行中药行的两大原则:<br />
							「修和无人见，存心有天知」<br />
							「炮制虽繁必不敢省人工，<br />
							品味虽贵必不敢减物力」<br />
						</div>
						<div class="pageBoxMainTopLeftImg">
							<img class="topLeftImg" src="../assets/yiBrand/ideaImg1.png" alt="">
						</div>
					</div>

					<div class="pageBoxMainBottom">
						<div class="pageBoxMainTopLeftImg">
							<img class="topLeftImg" src="../assets/yiBrand/ideaImg2.png" alt="">
						</div>
						<div class="pageBoxMainTopLeftTitle pageBoxMainTopLeftTitleNew">
							严格遵循国家规定，<br />
							精选上乘原料、研制优质产品，<br />
							多方位修护问题性肌肤，重现肌肤<br />
							自然美、平衡美、活力美。
						</div>
					</div>
				</div>
			</div>
			<div class="section pageBox5">
				<div class="pageMainItem5">
					<div class="pageMainItemContent pageMainItemContent1">
						<div class="pageMainItemImgOuter">
							<img class="pageMainItemImg" src="../assets/yiBrand/yiqingtangTe.png" alt="">
						</div>
						<div class="pageMainItemContentT busiz-text-ellipes1">修有道，养有方</div>
					</div>
					<div class="pageMainItemContent pageMainItemContent2">
						<div class="pageMainItemImgOuter">
							<img class="pageMainItemImg" src="../assets/yiBrand/yiqingNewMiddle.jpg" alt="">
						</div>
						<div class="pageMainItemContentT busiz-text-ellipes1">草本提取，植本清芳</div>
					</div>
					<div class="pageMainItemContent pageMainItemContent3">
						<div class="pageMainItemImgOuter">
							<img class="pageMainItemImg" src="../assets/yiBrand/yi3.png" alt="">
						</div>
						<div class="pageMainItemContentT busiz-text-ellipes1">修护、预防、保养三合一</div>
					</div>
				</div>
			</div>
			<div class="section pageBox6">
				<div class="pageBoxOut2">
					<!-- 底部 -->
					<div class="footerBox">
						<div class="footerBoxHeader">
							<div class="footerBoxHeaderLeft">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树公众号</span>
							</div>
							<div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
								<span class="codeText">兰树云小程序</span>
							</div>
							<!-- <div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树客服(QQ)</span>
							</div> -->

						</div>
						<div class="footerMainBox">
							<li class="footerShop"><a target="_blank"
									href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
							</li>
							<li class="footerShop"><a target="_blank"
									href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
							</li>
							<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a>
							</li>
							<li class="footerShop"><a target="_blank"
									href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
							</li>
							<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com">Dr.CHUNG<span
										style="vertical-align: super;">+</span>旗舰店</a></li>
							<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
							<div class="lastHeader">
								<li>
									<router-link to="/login" tag="a">登录</router-link>
								</li>
								|
								<li>
									<router-link to="/login" tag="a">注册</router-link>
								</li>
							</div>
						</div>

						<div class="footerInfoBox">
							<div class="emailBox">邮箱: postermaster@lasur.com</div>
							<div class="phoneBox">电话: 0571-89025888</div>
							<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
						</div>



						<div class="footerLine"></div>
						<div class="footerBoxBottom">
							<div class="footerLeft">
								Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank"
									href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a>
							</div>

						</div>
					</div>
				</div>
			</div>
		</full-page>
	</div>
</template>

<script>
export default {
	data() {
		return {
			options: {
				licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
				//是否显示导航，默认为false
				navigation: true,
			},
			brandActive: 1,
		}
	},
	methods: {
		enterProducts(id) {
			this.$router.push({ path: '/productsList', query: { brandId: id } });
		},
		enterHome() {
			this.$router.push({ path: '/' });
		}
	}
}
</script>

<style scoped>
.yiContainer {
	margin: 0;
	padding: 0;
	position: relative;
}


.pageBoxOut2 {
	width: 90%;
	height: 100%;
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	box-sizing: border-box;
}

/* 导航 */

/* 下拉菜单栏 选中 */
.elDropdown_active {
	background-color: #FFFFFF !important;
	color: #000000 !important;
}

.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #FFFFFF;
	/* border-bottom:1px solid rgba(255,255,255,0.2); */
	z-index: 999;
}

.router-link-active {
	background-color: #0F3F93 !important;
	color: #FFFFFF !important;
}

.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
}


.navBarItem li {
	/* list-style: none;
		padding: 1.5em 2.5em 1.5em 2.5em;
		float: left; */
	list-style: none;
	/* padding: 25px 40px 25px 40px; */
	float: left;
	/* margin-left: 2em; */
}

.brandLi a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.6em !important;
	padding-bottom: 1.6em !important;
	padding-left: 2em;
	padding-right: 2em;
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.4em;
	padding-bottom: 1.4em;
	padding-left: 1.4rem;
	padding-right: 1.4rem;
}

/* .elDropdown{
		margin-left: -7.5em;
		margin-top: -1em;
	} */

.elDropdown a {
	color: #111111;
	text-decoration: none;
}

.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 12px;
}


/* pageBox1 */

.pageBox1 {
	width: 100%;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-30_09-32-59_1258.jpeg) no-repeat;
	background-position: 50% 45%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
}

.topBgBox {
	width: 21%;
	float: right;
	display: flex;
	align-items: center;
	top: 30%;
	right: 0%;
	cursor: pointer;
	position: relative;
	opacity: 0.5;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: topbgbox 1.5s;
	-webkit-animation: topbgbox 1.5s;
}

.topBgBoxImg {
	width: 100%;
}

.pageBox1.active .topBgBox {
	right: 16%;
	opacity: 1;
}

/* 动画 topbgbox */
/* first 图1动画 */
@keyframes topbgbox {
	from {
		opacity: 0;
		right: 0;
	}

	to {
		opacity: 1;
		right: 16%;
	}
}

@-webkit-keyframes topbgbox

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		right: 0;
	}

	to {
		opacity: 1;
		right: 16%;
	}
}


/* pageBox2 */

.pageBox2 {
	width: 100%;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-43-21_32708.jpeg) no-repeat;
	background-position: center 85%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}


.pageBoxBody2 {
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
}

.pageBoxBodyImg {
	width: 60%;
	margin-top: 14%;
}



/* pageBox3 */
.pageBox3 {
	width: 100%;
	background: url(../assets/yiBrand/pinpaiqiyuan.jpg) no-repeat;
	background-position: 50% 30%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: auto;
}

.pageBoxItemBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	justify-content: center;
	margin-top: 15%;
	align-items: center;
}

.ItemBoxLeftImg {
	width: 100%;
}


.pageBoxItemBoxLeft {
	width: 25%;
	position: relative;
	left: -20rem;
	opacity: 0.5;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox3.active .pageBoxItemBoxLeft {
	left: 0;
	opacity: 1;
}

.pageBoxItemBoxRight {
	width: 25%;
	display: flex;
	flex-direction: column;
	margin-left: 4rem;
}

.pageBoxItemBoxRightImg {
	width: 100%;
	margin-top: 1rem;
	position: relative;
	left: 20rem;
	opacity: 0.5;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox3.active .pageBoxItemBoxRightImg {
	left: 0;
	opacity: 1;
}

.ItemBoxRightImg {
	width: 100%;
}

.pageBoxItemBoxRightText {
	font-size: 1.125rem;
	font-family: PingFang;
	color: #2A2A2A;
	line-height: 26px;
}

/* pageBox4 */
.pageBox4 {
	width: 100%;
	background: url(../assets/yiBrand/linian.jpg) no-repeat;
	background-position: 50% 30%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.pageBoxMain4 {
	width: 50%;
	margin: 0 auto;
	background-color: #FFFFFF;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 14%;
}

.pageBoxMainTop {
	display: flex;
	flex-direction: row;
	width: 90%;
	margin: 0 auto;
	padding-top: 1.5rem;
}

.pageBoxMainBottom {
	display: flex;
	flex-direction: row;
	width: 90%;
	margin: 0 auto;
	padding-bottom: 1.5rem;
}

.pageBoxMainTopLeftTitle {
	font-size: 1.125rem;
	width: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: PingFang;
	font-weight: 200;
	color: #222222;
	line-height: 28px;
}



.pageBoxMainTopLeftImg {
	width: 10%;
	position: relative;
	opacity: 0.5;
	-moz-transition: 1s;
	-webkit-transition: 1s;
}

.pageBox4.active .pageBoxMainTopLeftImg {
	opacity: 1;
	width: 50%;
}

.topLeftImg {
	width: 100%;
}


/* pageBox5 */
.pageBox5 {
	width: 100%;
	background: url(../assets/yiBrand/tese.jpg) no-repeat;
	background-position: 50% 30%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden;
}



.pageMainItem5 {
	width: 100%;
	margin: 0 auto;
	align-items: center;
	display: flex;
	justify-content: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 15%;
}


.pageMainItemContent {
	width: 16%;
	display: flex;
	flex-direction: column;
}

.pageMainItemContent1 {
	position: relative;
	opacity: 0.5;
	top: -10rem;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox5.active .pageMainItemContent1 {
	opacity: 1;
	top: 0;
}


.pageMainItemContent3 {
	position: relative;
	opacity: 0.5;
	top: -10rem;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox5.active .pageMainItemContent3 {
	opacity: 1;
	top: 0;
}


.pageMainItemContent2 {
	position: relative;
	opacity: 0.5;
	top: 10rem;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox5.active .pageMainItemContent2 {
	opacity: 1;
	top: 0;
}


.pageMainItemImgOuter {
	width: 100%;
}

.pageMainItemImg {
	width: 100%;
}

.pageMainText5 {
	width: 35%;
	margin: 0 auto;
	font-size: 1rem;
	font-family: PingFang;
	color: #2A2A2A;
	line-height: 20px;
	text-align: center;
}

.pageMainItemContentT {
	text-align: center;
	line-height: 50px;
	font-size: 1rem;
	font-family: PingFang;
	font-weight: 400;
	color: #2A2A2A;
	background-color: #FFFFFF;
	position: relative;
	top: -3rem;
}

.busiz-text-ellipes1 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}

/* pageBox6 */
.pageBox6 {
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: #2F558A;
}


/* footer */
.footerBox {
	width: 90%;
	/* height: 287px; */
	/* position:absolute;
	   	bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
}


.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}

.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderMiddle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}



.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #FFFFFF;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}


.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}



.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 24px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
}

.footerLeft a:hover {
	color: #003F98;
}

.footerMiddle {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerMiddle span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 24px;
}

.footerRight {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerRight li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 28px;
}

.footerRight li {
	list-style: none;
}

.footerLast {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerLast span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}



.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span{
	margin-right: 10px;
}
.footerShop span::after{
	content: '+';
	display:block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	padding-left: 2em;
	line-height: 28px;
	cursor: pointer;
}

.seriesTitle {
	margin: 0 auto;
	text-align: center;
	font-size: 2rem;
	margin-top: 2%;
	font-weight: bold;
	font-family: simsun;

}

.seriesMainBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 4%;
}

.seriesMainBoxItem {
	width: 100%;
}

.seriesItemImg {
	width: 30%;
	cursor: pointer;
}

.seriesItemImg1 {
	position: relative;
	left: 0%;
	top: 5rem;
	opacity: 0;
	-moz-transition: 0.8s;
	-webkit-transition: 0.8s;
}

.pageBox2.active .seriesItemImg1 {
	left: 35%;
	opacity: 1;
}

.seriesItemImg2 {
	position: relative;
	left: 0%;
	top: 0rem;
	opacity: 0;
	-moz-transition: 0.8s;
	-webkit-transition: 0.8s;
}

.pageBox2.active .seriesItemImg2 {
	left: 14%;
	opacity: 1;
}

.seriesItemImg3 {
	position: relative;
	float: right;
	right: 0%;
	top: 0rem;
	opacity: 0;
	-moz-transition: 0.8s;
	-webkit-transition: 0.8s;
}

.pageBox2.active .seriesItemImg3 {
	right: 20%;
	opacity: 1;
}

.seriesItemImg4 {
	position: relative;
	float: right;
	right: 0%;
	top: 3rem;
	opacity: 0;
	-moz-transition: 0.8s;
	-webkit-transition: 0.8s;
}

.pageBox2.active .seriesItemImg4 {
	right: 40%;
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/yiBrand22.vue